/*
 * Created on Tue May 14 2019
 *
 * Copyright (c) 2019 Sébastien Hecart
 */
//
import { RCoeffGDeta_Type, RVitrage_Type } from '@batical/types/src'
import i18n from '@batical/i18n'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const Data = require('../json/CoeffGDeta.json')
const RVitrage = require('../json/Vitrage.json')
export function fetchCoeffGDetaMursSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'mur'))
}

export function fetchCoeffGDeta(uuid: string): RCoeffGDeta_Type {
  return fetchGeneric(Data, uuid)
}

export function fetchCoeffGPlafondSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'plafond'))
}

export function fetchCoeffGDetaIsolantSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'isolant'))
}

export function fetchCoeffGDetaPlancherSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'plancher'))
}

export function fetchCoeffGDetaPorteSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'porte'))
}

export function fetchGDetaVentilationSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(Data.filter((item: RCoeffGDeta_Type) => item.type === 'ventilation'))
}

//page detail

export function fetchCoeffGDetaTypeVitrageSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(RVitrage)
}

export function fetchRVitrage(uuid: string): RVitrage_Type {
  return fetchGeneric(RVitrage, uuid)
}

export function fetchCoeffGDetaOrientationSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'orientation_N', label: i18n.t('orientation_N') },
    { value: 'orientation_NE', label: i18n.t('orientation_NE') },
    { value: 'orientation_E', label: i18n.t('orientation_E') },
    { value: 'orientation_SE', label: i18n.t('orientation_SE') },
    { value: 'orientation_S', label: i18n.t('orientation_S') },
    { value: 'orientation_SO', label: i18n.t('orientation_SO') },
    { value: 'orientation_O', label: i18n.t('orientation_O') },
    { value: 'orientation_NO', label: i18n.t('orientation_NO') }
  ]
}

export function fetchCoeffGDetaOrientation(uuid: string): string {
  const imte = fetchCoeffGDetaOrientationSorted().find(item => (item.value = uuid))
  return imte ? imte.label : ''
}

export function fetchCoeffGDetaPositionPlancherSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'pos_plancher_0', label: i18n.t('pos_plancher_0') },
    { value: 'pos_plancher_1', label: i18n.t('pos_plancher_1') },
    { value: 'pos_plancher_2', label: i18n.t('pos_plancher_2') },
    { value: 'pos_plancher_3', label: i18n.t('pos_plancher_3') }
  ]
}

export function fetchCoeffGDetaPositionPlancher(uuid: string): string {
  const ers = fetchCoeffGDetaPositionPlancherSorted().find(item => (item.value = uuid))
  return ers ? ers.label : ''
}

export function fetchCoeffGDetaPositionPlafondSorted(): Array<{
  value: string
  label: string
}> {
  return [
    { value: 'pos_plafond_0', label: i18n.t('pos_plafond_0') },
    { value: 'pos_plafond_1', label: i18n.t('pos_plafond_1') },
    { value: 'pos_plafond_2', label: i18n.t('pos_plafond_2') }
  ]
}

export function fetchCoeffGDetaPositionPlafond(uuid: string): string {
  const res = fetchCoeffGDetaPositionPlafondSorted().find(item => (item.value = uuid))
  return res ? res.label : ''
}
